/**
 * Labstep - Handle Menu Component
 *
 * Context menu for table handle actions (add/delete rows/columns)
 */

import React, { type FC, useEffect, useRef } from 'react';
import styles from './styles.module.scss';

export interface HandleMenuProps {
  isOpen: boolean;
  position: { top: number; left: number };
  onClose: () => void;
  onAddBefore: () => void;
  onAddAfter: () => void;
  onDelete: () => void;
  type: 'row' | 'column';
}

export const HandleMenu: FC<HandleMenuProps> = ({
  isOpen,
  position,
  onClose,
  onAddBefore,
  onAddAfter,
  onDelete,
  type,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          menuRef.current &&
          !menuRef.current.contains(event.target as Node)
        ) {
          onClose();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () =>
        document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      ref={menuRef}
      className={styles.handleMenu}
      style={{ top: position.top, left: position.left }}
    >
      <div onClick={onAddBefore} className={styles.handleMenuOption}>
        Add {type} {type === 'row' ? 'above' : 'to left'}
      </div>
      <div onClick={onAddAfter} className={styles.handleMenuOption}>
        Add {type} {type === 'row' ? 'below' : 'to right'}
      </div>
      <div className={styles.handleMenuDivider} />
      <div
        onClick={onDelete}
        className={`${styles.handleMenuOption} ${styles.danger}`}
      >
        Delete {type}
      </div>
    </div>
  );
};
